/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  var Z63 = (function (parent, $) {

	    var MediaQueryListener = function() {
	        this.afterElement = window.getComputedStyle ? window.getComputedStyle(document.body, ':after') : false;
	        this.currentBreakpoint = '';
	        this.lastBreakpoint = '';
	        this.init();
	    };

	    MediaQueryListener.prototype = {

	        init: function () {
	            var self = this;

	            if(!self.afterElement) {
	                return;
	            }

	            self._resizeListener();

	        },
	        _resizeListener: function () {
	            var self = this;

	            $(window).on('resize orientationchange load', function() {
	                // Regexp for removing quotes added by various browsers
	                self.currentBreakpoint = self.afterElement.getPropertyValue('content').replace(/^["']|["']$/g, '');

	                if (self.currentBreakpoint !== self.lastBreakpoint) {
	                    $(window).trigger('breakpoint-change', self.currentBreakpoint);
	                    self.lastBreakpoint = self.currentBreakpoint;
	                }

	            });
	        }

	    };

	    parent.mediaqueryListener = parent.mediaqueryListener || new MediaQueryListener();

	    return parent;

	}(Z63 || {}, jQuery));

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {



        debounce = function(func, wait, immediate) {
      	    var timeout;
      	    return function() {
      	        var context = this, args = arguments;
      	        clearTimeout(timeout);
      	        timeout = setTimeout(function() {
      	            timeout = null;
      	            if (!immediate) func.apply(context, args);
      	        }, wait);
      	        if (immediate && !timeout) func.apply(context, args);
      	    };
      	};

        // debounced resize event
      	var resizeDebounce = debounce(function() {

      	}, 100);
      	window.addEventListener('resize', resizeDebounce);


      	// scroll function
      	var scrollDebounce = debounce(function() {

      	}, 50);
      	window.addEventListener('scroll', scrollDebounce);




      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
